import "./App.css";

import React, { useState, useRef, useMemo, useEffect} from "react";

import MobileCard from "./components/MobileCard";
import Video from "./components/Video";
import ScreenImage from "./components/ScreenImage";
import ScreenImageTitle from "./components/ScreenImageTitle";
import Title from "./components/Title";
import ScrollVideo from "./components/ScrollVideo";
import { ProgressBar } from "./components/ProgressBar";
import NavBar from "./components/NavBar";
import Map from "./components/Map";


import { processData } from "./data/process";
import mobile_data from "./data/mobile_data";

function MobileApp() {
  const {
    frames,
    slides: allSlides,
  } = useMemo(() => {
    return processData(mobile_data);
  }, []);

  const [currentSlide, setCurrentSlide] = useState(0);
  console.log(currentSlide);

  const ref = useRef();

  const MAPBOX_token="pk.eyJ1IjoiYWlyd2FycyIsImEiOiJjbWE2ZGN0bTQwMXhmMmtzZ2VwYnUyOTZ1In0.bf2sZeJioIZr_xM6xsXLzw"
  const mapStyle = currentSlide >= 13 ? "mapbox://styles/mapbox/satellite-v9" : "mapbox://styles/mapbox/light-v11"

  const allWrapperStyle = {
    position: "relative",
    overflow: "scroll",
    height: "100vh",
    width: "100vw",
  };

  const mapContainerStyle = {
    height: "100%",
    width: "100%",
    position: "fixed",
    zindex:100,
  };

  const TOTAL_FRAMES = 191;

  const [imgsLoaded, setImgsLoaded] = useState(false)

  useEffect(() => {

    const imgs = []
    for  (var i = 0; i < TOTAL_FRAMES; i++){
        const formattedFrame = i.toString().padStart(3, "0");
        imgs[i]=`MobileFrames/Documents_FramesMobile${formattedFrame}.jpg`
    }
    //console.log (imgs)

    const promises  = imgs.map ((src)=> {
      return new Promise ((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => resolve(img));
        img.addEventListener('error', (err) => reject(err));
        img.src = src;
      });
    });

    Promise.all(promises).then((res) =>
    setImgsLoaded(true));
    }, []);
  

  const renderMobileSlides = (slidesList) => {
    return (
      <div id="all-cards-container">
        <MobileCard
          slidesContent={slidesList}
          callbackFromParent={setCurrentSlide}
        />
      </div>
    );
  };

  return (
    <div id={"all"} ref={ref} style={allWrapperStyle}>
    <NavBar isMobile={true} elementId="all"/>  
    <ProgressBar elementId="all"/>  
    <Video isMobile={true} currentSlide={allSlides[currentSlide]} />
    {ref.current ? (
    <ScrollVideo
      divRef={ref}
      chapterStartSlide={0}
      currentSlide={allSlides[currentSlide]}
      videoSettings={frames}
      isMobile={true}
    />
    ) : null}
    <ScreenImage isMobile={true} currentSlide={allSlides[currentSlide]} />
    <ScreenImageTitle isMobile={true} currentSlide={allSlides[currentSlide]} />
    <Title isMobile={true} currentSlide={allSlides[currentSlide]} />
    {ref.current ? (
            <div
              style={mapContainerStyle}
            >
              <Map
                divRef={ref}
                currentSlide={allSlides[currentSlide]}
                viewState={{
                  ...allSlides[currentSlide].viewState,
                  }}
                MAPBOX_TOKEN={MAPBOX_token}
                mapStyle= {mapStyle}
                isMobile={false}
              />
            </div>
          ) : null}
    {renderMobileSlides(allSlides)}
  </div>
  );
}

export default MobileApp;
